import { configureStore } from '@reduxjs/toolkit'
import secretSantaSlice from './SecretSantaSlice'

export default configureStore({
    reducer: {
        secretSantaInfo: secretSantaSlice
    }
})